import { useEffect, useState } from 'react'
import './style.css'
import AllDropDownsAHSF from '../../Components/AllDropDownsAHSF'
import { useDispatch, useSelector } from 'react-redux'
import { AddStagesAction } from '../../Redux/Reducers/ReportStage/Stages'
import ButtonAHSF from '../../Components/ButtonAHSF'
import Swal from 'sweetalert2'
import { setRefreshTable } from '../../Redux/Reducers/VariousVariables'
import $ from "jquery";
const AddStages = (props) => {
    const [implementationDurartion, setImplementationDurartion] = useState(null)
    const [validationBoreder, setValidationBoreder] = useState(false)
    const dispatch = useDispatch();


    const AddReportStage = () => {
        if (implementationDurartion == null) {
            setValidationBoreder(true)
        } else {
            dispatch(AddStagesAction({
                implementationDurartion: implementationDurartion,
                appGuid: props.appGuid
            }))

            $(".close-btn").trigger("click"); // Simulate click to close modal

            Swal.fire({
                position: "center",
                icon: "success",
                title: "تم اضافة المعلومات بنجاح", // Success message in Arabic
                showConfirmButton: false,
                timer: 1500, // Auto-close after 1.5 seconds
            });
        }
    }

    return (
        <div className='containerReportStage'>
            <div className='ChaildcontainerReportStage'>
                <div>
                    <AllDropDownsAHSF
                        fieldsName="reportStageImplementation"
                        show={true}
                        disabled={false}
                        dropdownType="normal"
                        arrayOoptionList={[{ value: 1, text: "1" }, { value: 2, text: "1" }, { value: 3, text: "1" }, { value: 4, text: "1" }, { value: 5, text: "1" }, { value: 6, text: "1" }, { value: 7, text: "1" }, { value: 8, text: "1" }, { value: 9, text: "1" }, { value: 10, text: "1" }, { value: 11, text: "1" }, { value: 12, text: "1" }, { value: 13, text: "1" }, { value: 14, text: "1" }, { value: 15 }, { value: 16, text: "1" }]}
                        KeyText={"value"}
                        KeyValue={"value"}
                        // defaultValue={""}
                        onChange={(e) => {
                            setImplementationDurartion(e.target.value);
                        }}
                        showValidationMessage={
                            validationBoreder
                        }
                        validationMessage="يرجى تعبئة هذا الحقل"
                    />
                </div>

                <div className='containerButton'>
                    <button className="custom-button" onClick={() => {
                        AddReportStage()

                    }}>
                        حفظ
                    </button>

                </div>
            </div>
        </div>
    )
}

export default AddStages